<template>
    <div class="home" :style="{ '--chrome': chromeHeight + 'px' }">
      <h1 class="visually-hidden">Arne Reckhaus aus Garbsen – Solution Architect &amp; Lead Developer in der Region Hannover</h1>
      <ServiceGlobe></ServiceGlobe>
    </div>
</template>

<script>
// @ is an alias to /src
import ServiceGlobe from "../components/Home/ServiceGlobe";

export default {
  name: 'Home',
  components: {
    ServiceGlobe
  },
  computed: {
    // App-Bar + Footer, damit die Kugel genau den sichtbaren Bereich füllt
    chromeHeight() {
      const { top, footer } = this.$vuetify.application
      return top + footer
    },
  },
}
</script>

<style scoped>
.home {
  height: calc(100vh - var(--chrome));
  height: calc(100dvh - var(--chrome));
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
